/* eslint-disable */
import licenze from "@/services/licenzeService.js";
import prodotti from "@/services/prodottiService.js";

export const verificaLicenza = {
  data() {
    return {
      token: ""
    };
  },
  methods: {
    async gestioneToken() {
      this.token = await licenze.getToken();
      console.log(this.token);
      if (this.isTokenValid(this.token)) {
        console.log("Letto token", this.token);
        // Aggiorna il token trovato
        localStorage.setItem("token", JSON.stringify(this.token));
      } else {
        console.log("Token da localStorage");
        if (this.isTokenValid(localStorage.getItem("token"))) {
          try {
            this.token = JSON.parse(localStorage.getItem("token"));
            console.log("token valido ---- ", this.token);
          } catch (e) {
            console.log("Errore gestione token da local storage", e.message);
            localStorage.removeItem("token");
            this.token = "";
          }
        } else {
          this.token = "";
          console.log("token non valido", localStorage.getItem("token"));
        }
      }
      const verifica = await licenze.verifyToken(this.token);
      const moduloFattureElettroniche =
        verifica &&
        verifica.moduli &&
        verifica.moduli.findIndex(x => x === "fatturazioneElettronica") > -1;
      if (moduloFattureElettroniche) {
        localStorage.setItem("display_fe", true);
      } else {
        localStorage.removeItem("display_fe");
      }
      console.log(verifica);
      const event = null;
      switch (verifica.stato) {
        case "token.scaduto": // blocca l'applicazione
          this.$router.push("/token");
          break;
        case "token.inScadenza": // segnala di ricollegare
          this.context.displayMessage = `Ricordati di collegare la rete... Hai solo ${
            verifica.oreToken
          } ${verifica.oreToken === 1 ? "ora" : "ore"} per farlo`;
          break;
        case "licenza.scaduta": // blocca l'applicazione
          this.$router.push("/licenza");
          break;
        case "licenza.inScadenza": // segnala di aggiornare la licenza
          this.context.displayMessage = `Attenzione! La licenza scade tra ${
            verifica.giorniLicenza
          } ${verifica.giorniLicenza === 1 ? "giorno" : "giorni"}...`;
          break;
        default:
          break;
      }
      if (event) {
        this.displayService.send(event);
      } else {
        prodotti.setToken(this.token);
      }
    },
    // Send events to the service
    sendEvent(event) {
      this.displayService.send(event);
    },
    isTokenValid(token) {
      if (!token) return false;
      if (Array.isArray(token) && token.length == 0) return false;
      if (token == "") return false;
      if (JSON.stringify(token) === "{}") return false;
      return true;
    }
  }
};
